import type { FC } from "react";

import classNames from "classnames";
import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Dropdown } from "@similarweb/ui-components";

import { GroupDropdownMenuItem } from "app/components/dropdown/GroupDropdownMenuItem";
import { translate } from "app/filters/i18nFilter";
import type { IPeriodOverPeriodCompareType } from "app/services/periodOverPeriodTypes";

import type { PeriodOverPeriodCompareTypes } from "./types";

const { carbon } = colorsPalettes;

const DISABLED_COLOR = carbon[100];

interface PeriodOverPeriodComprareTypesMenuProps {
    periodOverPeriodCompareTypes: PeriodOverPeriodCompareTypes;
    onSelectCompareType: (item: { id: IPeriodOverPeriodCompareType }) => void;
    isDisabled: boolean;
    labelKey: string;
}

const Label = styled.div<{ $color: string }>`
    ${({ $color = carbon[300] }) => setFontVariant("input2", $color)}
`;

const IconContainer = styled.div`
    box-sizing: border-box;
    height: 60px;
    display: flex;
    align-items: center;
    width: 61px;
    justify-content: flex-end;
    gap: 8px;
    padding-left: 4px;
    padding-right: 8px;
`;

export const PeriodOverPeriodComprareTypesMenu: FC<PeriodOverPeriodComprareTypesMenuProps> = ({
    periodOverPeriodCompareTypes,
    onSelectCompareType,
    isDisabled,
    labelKey,
}) => {
    return (
        <Dropdown
            appendTo="body"
            width="290px"
            onClick={onSelectCompareType}
            closeOnItemClick={true}
            disabled={isDisabled}
            data-automation="period-over-period-compare-types-menu"
            cssClassContainer={classNames("DropdownContent-container", "FiltersBarDropdown")}
        >
            {[
                <IconContainer key="period-over-period-button">
                    <Label $color={isDisabled ? DISABLED_COLOR : undefined}>{translate(labelKey)}</Label>
                    <SWReactIcons
                        iconName="arrow"
                        iconColor={isDisabled ? DISABLED_COLOR : undefined}
                    />
                </IconContainer>,
                ...periodOverPeriodCompareTypes.map(
                    ({ id, title, description, isDisabled: itemDisabled, isSelected }) => (
                        <GroupDropdownMenuItem
                            key={id}
                            id={id}
                            title={translate(title)}
                            description={translate(description)}
                            isDisabled={itemDisabled}
                            isSelected={isSelected}
                        />
                    ),
                ),
            ]}
        </Dropdown>
    );
};
